var React = require('react');

function FrontendNavigationForms (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000000","d":"M13.5 0h-12c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h12c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM13 14h-11v-12h11v12zM4 7h7v1h-7zM4 9h7v1h-7zM4 11h7v1h-7zM4 5h7v1h-7z"}));
}

FrontendNavigationForms.displayName = "FrontendNavigationForms";

FrontendNavigationForms.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = FrontendNavigationForms;

FrontendNavigationForms.default = FrontendNavigationForms;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/frontend-navigation-forms.svg
// module id = 1736
// module chunks = 0